var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadProductImgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9996 15.465V54.5346C69.9961 58.6351 68.3657 62.5667 65.4662 65.4662C62.5667 68.3657 58.6351 69.9961 54.5346 69.9996H15.465C13.7471 70.0046 12.0408 69.7184 10.4185 69.1531C7.37723 68.1027 4.73918 66.13 2.87175 63.5098C1.00432 60.8895 0.000475103 57.7522 0 54.5346V15.465C0.00344872 11.3645 1.6339 7.43292 4.53341 4.53341C7.43292 1.6339 11.3645 0.00344872 15.465 0H54.5346C58.6351 0.00344872 62.5667 1.6339 65.4662 4.53341C68.3657 7.43292 69.9961 11.3645 69.9996 15.465Z",
    fill: "#E6ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0106 25.6403C28.5059 25.6403 32.1501 21.9961 32.1501 17.5008C32.1501 13.0055 28.5059 9.36133 24.0106 9.36133C19.5153 9.36133 15.8711 13.0055 15.8711 17.5008C15.8711 21.9961 19.5153 25.6403 24.0106 25.6403Z",
    fill: "#F7D300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M69.999 38.3856V54.5344C69.9956 58.6349 68.3651 62.5665 65.4656 65.466C62.5661 68.3655 58.6345 69.9959 54.534 69.9994H15.4645C13.7465 70.0044 12.0402 69.7182 10.418 69.1529L46.2317 33.3391C47.5546 32.0061 49.2646 31.1248 51.1179 30.8207C52.9712 30.5167 54.8731 30.8056 56.5526 31.6461L69.999 38.3856Z",
    fill: "#2820DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9715 47.5993L20.6092 39.0694C19.1324 37.9547 17.3451 37.3276 15.4955 37.2751C13.646 37.2226 11.826 37.7473 10.2883 38.7764L0 45.6461V54.5344C0.000475103 57.752 1.00432 60.8894 2.87175 63.5096C4.73908 66.1297 7.37696 68.1023 10.4181 69.1528L31.9715 47.5993ZM43.9532 69.9994H15.4645C15.0686 70.0005 14.6735 69.9862 14.2798 69.9566C14.6736 69.9863 15.069 70.0006 15.465 69.9995H43.9532V69.9994Z",
    fill: "#2820DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProductImgLogo);
export default __webpack_public_path__ + "static/media/Upload_product_img_logo.635f6a2f5f3a9609609433725dbdcc81.svg";
export { ForwardRef as ReactComponent };